import styled from "styled-components";

const StepHeaderMetadata = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export default StepHeaderMetadata